import { EStepType } from '../types';

/** Matches whole `_`-separated words, so `wait_for_selector` isn't a click. */
const word = (...words: string[]) =>
  new RegExp(`(^|_)(${words.join('|')})(_|$)`);

const ACTION_KEYWORDS: ReadonlyArray<[RegExp, EStepType]> = [
  [
    word('navigate', 'navigation', 'go_to', 'goto', 'open_url'),
    EStepType.NAVIGATE,
  ],
  [word('click', 'select', 'tap'), EStepType.CLICK],
  [word('type', 'input', 'fill', 'press', 'key'), EStepType.TYPE],
  [word('done', 'extract', 'output', 'complete'), EStepType.OUTPUT],
];

/**
 * Map an executor `action_type` onto the icon category shown beside a step.
 *
 * Matches by keyword rather than exact name so new executor actions
 * (`click_element`, `input_text`, ...) land in the right bucket without a
 * frontend change. Unknown or missing actions fall back to GOAL.
 *
 * @param actionType - Raw `action_type` from metadata.json
 * @returns Step type for {@link StepTypeIndicator}
 */
export function getStepTypeFromAction(actionType?: string | null): EStepType {
  if (!actionType) return EStepType.GOAL;
  const normalized = actionType.toLowerCase();
  for (const [pattern, type] of ACTION_KEYWORDS) {
    if (pattern.test(normalized)) return type;
  }
  return EStepType.GOAL;
}
